import { GanttZoomScale, GanttZoomScaleDefault, GanttZoomScaleMax, GanttZoomScaleMin } from "@ms/uno-constants/lib/local/GanttZoomConstants";
/**
 * Validates and normalizes a stored zoom scale value.
 * Returns the value as a GanttZoomScale if valid, otherwise returns the default.
 */ export function getValidatedZoomScale(storedValue) {
    return storedValue !== null && Number.isInteger(storedValue) && storedValue >= GanttZoomScaleMin && storedValue <= GanttZoomScaleMax ? storedValue : GanttZoomScaleDefault;
}
/**
 * Whether the due date indicator should be shown at the given zoom scale.
 *
 * Per design, the due date indicator is only rendered at the four most zoomed-in
 * levels (user-facing "1 week", "2 weeks", "1 month", "6 months" — i.e. SMALL,
 * MEDIUM, LARGE, SIXQUARTERS). At every level beyond that the indicator is hidden
 * because the day cells become too narrow to place the marker meaningfully.
 *
 * This is the single source of truth for the zoom gate; both the DOM and canvas
 * render paths rely on it (indirectly, via a null due-date position in the UI state).
 */ export function isDueDateVisibleAtZoom(scale) {
    return scale >= GanttZoomScale.SIXQUARTERS;
}
